(function($) {

  $(function() {

    $('#selector-search').on('click', function() {
      $('.selector-option').slideUp(200, function() {
        $('#selector-menu').css({
          display: ''
        });
      });
      if ($('.search-mobile').css('display') === 'block') {
        $('.search-mobile').slideUp();
      } else {
        $('.search-mobile').slideDown(200, function() {
          $(this).find('#search-mobile-input').trigger('focus');
        });
      }
      return false;
    });

    $('#search-mobile-input').on('focusout', function() {
      $('.search-mobile').slideUp();
    });

    $('#search-form #search').on('focus', function() {
      $(this).stop().animate({
        width: 140
      }).siblings('label').stop(true, true).fadeOut(200);
    }).on('blur', function() {
      $(this).stop().animate({
        width: 50
      });
      if ($(this).val() == '') {
        $(this).siblings('label').stop(true, true).fadeIn(200);
      }
    }).trigger('blur');

    $('#searchform, #search-form, #search-form-mobile').on('submit', function() {
      var value = $(this).find('input[type=text]').val();
      search(value);
      return false;
    });

    showResults();

  });

  function search(value) {
    setCookie('search', value, {
      'max-age': 60
    });
    window.location.href = 'search/';
  }

  function showResults() {
    if (window.location.pathname.includes('/search')) {
      var value = getCookie('search');
      if (value) {
        $('.search-value').text(value);
        $('.search-results').addClass('loading');
        $.getJSON("search.json").done(function (data) {
          const fuse = new Fuse(data, {
            includeScore: true,
            useExtendedSearch: true,
            ignoreLocation: true,
            ignoreFieldNorm: true,
            keys: [
              'title',
              'content',
              {
                name: 'description',
                weight: 0.8
              },
              {
                name: 'address',
                weight: 0.6
              },
              {
                name: 'tags',
                weight: 0.5
              },
              {
                name: 'website',
                weight: 0.5
              },
              {
                name: 'instagram',
                weight: 0.5
              }              
            ]
          });
          var results = fuse.search(value);
          if (results.length === 0) {
            $('.no-results').removeClass('hidden');
          } else {
            $('.no-results').addClass('hidden');
            results.forEach(data => {
              var article = $('<article class="bar-card" style="margin-bottom: 1.5rem;"></article>');
              if (data.item.selected) {
                article.removeClass('bar-card');
                article.addClass('bar-card-selected');
              }
              var row = $('<div class="row g-3 g-lg-4 align-items-stretch"></div>');
              var left = $('<div class="col-12 col-md-4 col-xl-3"></div>');
              var center = $('<div class="col-12 col-md-5 col-xl-6"></div>');
              var right = $('<div class="col-12 col-md-3 col-xl-3"></div>');
              var map = $('<div class="map-wrap h-100"></div>');
              var location = $(`<input type="hidden" class="map-location" value="${data.item.location}">`);
              var marker;
              if (data.item.marker) {
                marker = $(`<input type="hidden" class="map-marker" data-src="${data.item.marker}">`);
              }
              var frame = $(`<div class="map-frame"></div>`);
              var address = $(`<p class="bar-location mb-0"><i class="fa-solid fa-location-dot"></i> <a href="${data.item.yandex}">${data.item.address}</a></p>`);
              map.append(location);
              if (data.item.marker) {
                map.append(marker);
              }
              map.append(frame);
              map.append(address);
              right.append(map);
              var media = $('<div class="media-wrap h-100"></div>');
              var image = $(`<a href="${data.item.url}"><img class="bar-image" alt="Фото ${data.item.title}" loading="lazy" src="${data.item.banner}"></a>`);      
              var rating = $('<div class="media-overlay"><span class="bar-rating"><i class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i><i class="fa-regular fa-star"></i></span></div>');
              media.append(image);
              media.append(rating);
              left.append(media);
              var content = $('<div class="bar-content h-100 d-flex flex-column"></div>');
              var score = ((1 - data.score) * 100).toFixed(1).replace(/\.?0+$/, '');
              var h2 = $(`<h2 class="bar-title h4 mb-2"><a href="${data.item.url}">${data.item.title}</a></h2>`);
              h2.append(` <span style="color: rgba(255, 255, 255, 0.25)">${score}%</span>`);
              var worklist = data.item.worklist.replace(/,/g, ';;;');
              var p1 = $(`<p class="bar-meta mb-2">${data.item.price} • <span class="bar-hours" data-worklist="${worklist}"></span></p>`);
              if (data.item.recommended) {
                p1.append('<span class="bar-recommended"> • <i class="fa-solid fa-thumbs-up" title="Рекомендуем"></i></span>');
              }
              var p2 = $(`<p class="bar-description mb-3">${data.item.description}</p>`);
              var clear_tags = data.item.tag_links.replace(/\\n/g, '');
              var tags = $(`<div class="bar-tags d-flex flex-wrap gap-2 mt-auto">${clear_tags}</div>`);
              content.append(h2);
              content.append(p1);
              content.append(p2);
              content.append(tags);
              center.append(content);
              row.append(left);
              row.append(center);
              row.append(right);
              article.append(row);           
              $('.search-results').append(article);
            });
          }
        }).fail(function() {
          $('.fail-results').removeClass('hidden');
        }).always(function() {
          $('.search-results').removeClass('loading');
          window.mypubs.setMaps();
          window.mypubs.setRatings();
          window.mypubs.setStatuses();
        });
      } else {
        $('.search-results').addClass('hidden');
        $('.post-archive header').addClass('hidden');
        $('.fail-results').addClass('hidden');
      }
    }
  }

})(jQuery);